
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34452',
  depVersions: {
  "documents-public-ui": "static-1.34452",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34457",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2116",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5576",
  "hs-test-utils": "static-1.7996",
  "hub-http": "static-1.6204",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11450",
  "I18n": "static-7.1619",
  "jasmine-immutable": "static-1.3002",
  "jasmine-runner": "static-1.6448",
  "lodash": "static-1.3",
  "quartz": "static-1.7003",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16649",
  "reporting-data": "static-1.67447",
  "reporting-testing-lib": "static-1.9380",
  "reporting-visualizations": "static-1.59523",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4748",
  "webpack-env": "static-1.54",
  "atom": "static-1.5052",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2479",
  "classnames": "static-2.10",
  "cssUtils": "static-1.786",
  "customer-data-filters-ui": "static-1.39677",
  "customer-data-objects": "static-1.7645",
  "customer-data-property-utils": "static-1.8068",
  "data-fetching-client": "static-1.9652",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4497",
  "flux-actions": "static-1.334",
  "FormsCommonComponents": "static-1.85777",
  "FormUrlGenerator": "static-2.4700",
  "foundations-components": "static-1.7893",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11757",
  "icons": "static-2.644",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7140",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3827",
  "property-translator": "static-1.5382",
  "quartz-config": "static-1.781",
  "quartz-core": "static-1.6222",
  "quick-fetch": "static-1.3900",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5328",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8150",
  "reference-resolvers-lite": "static-1.8075",
  "report-customization-components": "static-1.13096",
  "reporting-enablement": "static-1.22838",
  "reporting-reports": "static-1.67125",
  "reporting-snowflake": "static-1.56065",
  "reporting-ui-components": "static-2.64718",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4632",
  "sales-content-partitioning": "static-1.8922",
  "SalesContentIndexUI": "static-3.9211",
  "sanitize": "static-1.4458",
  "sanitize-text": "static-1.8123",
  "self-service-api": "static-1.10229",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1729",
  "signup-constants": "static-1.18805",
  "signup-ui-lego-core": "static-1.20815",
  "signup-ui-url-generator": "static-2.8025",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4745",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10974",
  "ui-addon-i18n": "static-1.11132",
  "ui-addon-react-router-dom": "static-1.9526",
  "ui-addon-upgrades": "static-9.17955",
  "ui-asset-management-lib": "static-1.10996",
  "ui-images": "static-2.1147",
  "UIComponents": "static-3.8396",
  "usage-tracker": "static-1.7326",
  "usage-tracker-container": "static-1.7316",
  "usage-tracker-core": "static-1.7176",
  "usage-tracker-public": "static-1.7137",
  "viral-links-lib": "static-1.7039",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3387",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3280",
  "quartz-webpack": "static-1.3227",
  "ai-components-ui-library": "static-1.8881",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4846",
  "foundations-theming": "static-1.4400",
  "quartz-auth": "static-1.678",
  "ui-business-units-lib": "static-1.9030",
  "usage-tracker-session-replay": "static-1.5012",
  "foundations-theming-base": "static-1.3385",
  "HeadJS": "static-2.755",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3107",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.68",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4308",
  "csstype": "static-1.50",
  "quartz-head": "static-1.668",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7910",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3573",
  "persist-promise": "static-1.3678",
  "quartz-i18n": "static-1.678",
  "reporting-client-types": "static-1.2496",
  "foundations-components-legacy": "static-1.918",
  "hs-story-utils": "static-1.9408",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9909",
  "hubspotter-http": "static-1.4636",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.197",
  "conversations-skeleton-state": "static-1.7229",
  "crm-message-bus": "static-1.42928",
  "customer-data-filters-ui-msw-helpers": "static-1.22112",
  "customer-data-objects-ui-components": "static-1.13005",
  "customer-data-reference-ui-components": "static-1.13141",
  "customer-data-ui-utilities": "static-1.9808",
  "framework-builder-read-service-client": "static-1.3992",
  "framework-data-schema-quick-fetch": "static-1.6769",
  "framework-data-schema-resolvers": "static-1.6864",
  "inbound-db-properties-service-client": "static-1.3830",
  "multi-account-reference-resolvers": "static-1.959",
  "onboarding-tours": "static-1.16556",
  "reporting-datasets-permissions-lib": "static-1.13615",
  "ui-addon-teams": "static-1.21516",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68292",
  "customer-data-properties": "static-1.51462",
  "forms-ai-lib": "static-1.4286",
  "forms-utils-lib": "static-1.12536",
  "foundations-components-test-utils": "static-1.5376",
  "react-dnd-compat": "static-1.4600",
  "react-tinymce": "static-1.55176",
  "tinymce-config": "static-2.54302",
  "ui-gdpr-components": "static-1.10328",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4162",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.17",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1821",
  "ui-fonts": "static-1.712",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.530",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.433",
  "quartz-test": "static-1.678",
  "quartz-tracking": "static-1.382",
  "batch-promise": "static-1.1521",
  "external-options-client-types": "static-1.4142",
  "react-colorpicker": "static-2.10191",
  "ui-addon-draggable-compat": "static-2.4236",
  "copilot-toolkit": "static-1.11077",
  "data-quality-ui-library": "static-1.12939",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6443",
  "reporting-action-components": "static-1.41241",
  "reporting-filters": "static-1.279",
  "reporting-insights-lib": "static-1.1670",
  "reporting-plugins": "static-1.10289",
  "ui-addon-opt": "static-4.8352",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25307",
  "hubspot-apollo-client": "static-1.4859",
  "bend-plugin-chirp-manifest": "static-1.42",
  "chirp-fetch": "static-1.1868",
  "sales-templates-service-types-lib": "static-1.4154",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5849",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4064",
  "nested-table": "static-1.207",
  "timezone-utils": "static-2.5225",
  "bender-build-tools": "static-1.3171",
  "chatspot-core": "static-1.21180",
  "bend-plugin-foundations-theming": "static-1.2883",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9907",
  "hs-resources": "static-1.135",
  "pulse": "static-1.553",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3781",
  "crm-pipelines-api-client-types": "static-1.4125",
  "multi-currency-client-types": "static-1.3675",
  "getting-started-shared-tasks": "static-1.18439",
  "growth-data-modal": "static-1.5395",
  "growth-onboarding-confetti": "static-1.3048",
  "growth-onboarding-next-action-utils": "static-1.1854",
  "navigation-components": "static-1.17965",
  "onboarding-tours-client": "static-1.4770",
  "onboarding-tours-utils": "static-1.622",
  "ui-shepherd-react": "static-3.10139",
  "ui-shepherd-tracker": "static-1.7520",
  "ui-universal-auth": "static-1.8955",
  "user-context": "static-1.5084",
  "cms-field-types": "static-1.4792",
  "content-icons-ui": "static-1.2220",
  "integrations-lib": "static-1.16042",
  "calling-global-api": "static-1.64435",
  "calling-internal-common": "static-1.31282",
  "calling-lifecycle-internal": "static-1.65817",
  "calling-lifecycle-messages": "static-1.58111",
  "commerce-products-lib": "static-1.9473",
  "crm-links": "static-1.6267",
  "customer-data-properties-shared-msw-handlers": "static-1.9236",
  "file-manager-components": "static-1.23556",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4207",
  "meetings-icalendar-utils-lib": "static-1.612",
  "object-builder-ui-client": "static-1.48659",
  "pipeline-validation-client-types": "static-1.3949",
  "property-value-citations": "static-1.2076",
  "smart-property-lib": "static-1.6820",
  "tiered-pricing": "static-1.1151",
  "ui-addon-iframeable": "static-1.9038",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19790",
  "tinymce-themes": "static-1.56272",
  "data-token-picker": "static-1.16368",
  "hub-http-contrib": "static-1.3023",
  "interframe": "static-3.4742",
  "tinymce-data": "static-1.40387",
  "tinymce-plugins": "static-1.57416",
  "ui-addon-sales-email": "static-1.5193",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5540",
  "magpie-types": "static-1.5000",
  "simple-logging-lib": "static-1.3029",
  "content-assistance-lib": "static-1.7718",
  "dashboard-lib": "static-1.81431",
  "ExportDialog": "static-6.10373",
  "hubspot-prosemirror": "static-1.18180",
  "hubspot-prosemirror-plugins": "static-1.18172",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8685",
  "campaign-roi-lib": "static-1.9024",
  "feedback-loader": "static-1.29254",
  "apollo-link-hub-http": "static-2.4631",
  "hubspot-apollo-cache": "static-1.318",
  "purchase-motions-api": "static-1.5852",
  "trials-service-types": "static-1.3883",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.154",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.56",
  "directed-graph": "static-1.915",
  "event-emitter": "static-1.929",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1923",
  "growth-onboarding-next-action-components": "static-1.1882",
  "user-context-client": "static-1.4594",
  "idb-keyval": "static-1.43",
  "nest": "static-1.207",
  "reactive-lib": "static-1.703",
  "unified-auth-core-lib": "static-1.751",
  "getting-started-shared-tasks-store": "static-1.17557",
  "integrations-error-boundary-lib": "static-1.13457",
  "integrations-tracking-lib": "static-1.5580",
  "native-integrations-shared-strings": "static-1.7763",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10350",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.469",
  "calling-error-reporting": "static-1.31289",
  "shared-worker-versioning": "static-1.11019",
  "calling-usage-tracker": "static-1.6523",
  "voice-sms-access-library": "static-1.897",
  "customer-data-tracking": "static-1.6869",
  "commerce-permissions": "static-1.749",
  "products-iframe-lib": "static-1.7869",
  "products-ui-components-shared-msw-handlers": "static-1.10291",
  "location-customization-utils-lib": "static-1.9180",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4135",
  "video-components-external": "static-1.11194",
  "video-data-lib": "static-1.34852",
  "data-agent-kit": "static-1.160",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9992",
  "fsm": "static-1.3713",
  "policy-lib": "static-1.6759",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10055",
  "navigation-messaging": "static-1.7292",
  "FileManagerLib": "static-1.39196",
  "NamespacedHubStyle": "static-2.9043",
  "FileManagerCore": "static-1.39055",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12404",
  "layout-dnd-utils": "static-1.11379",
  "react-codemirror": "static-1.10607",
  "ui-addon-emoji-picker": "static-1.9870",
  "ui-brand-identity-lib": "static-1.15181",
  "ui-addon-video-player": "static-1.8684",
  "ui-coaching-tips": "static-1.28486",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23469",
  "EmailSignatureEditor": "static-1.24319",
  "breeze-engine-lib": "static-1.551",
  "InboxConnectUtils": "static-4.14751",
  "universal-page-editor-lib": "static-1.2994",
  "google-sheets-integration-lib": "static-1.168",
  "microsoft-drive-integration-lib": "static-1.283",
  "calling-orchestration-schema": "static-1.35674",
  "sales-views-client-types": "static-1.4245",
  "crm-record-cards-service-types": "static-1.3587",
  "content-media-composition-data-lib": "static-1.12179",
  "content-media-compositions": "static-2.16186",
  "media-bridge-lib": "static-1.18886",
  "trellis-story-utils": "static-1.4497",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5883",
  "FileManagerImages": "static-1.36707",
  "video-components": "static-1.13197",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4518",
  "video-embed": "static-1.35686",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68367",
  "layout-data-lib": "static-1.9704",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6563",
  "commerce-tours-lib": "static-1.6052",
  "growth-onboarding-reliability": "static-1.5064",
  "sales-checkout-service-client": "static-1.3621",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21634",
  "sales-email-signature-service-client": "static-1.3823",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22020",
  "outpost": "static-1.4166",
  "advanced-menus-core": "static-1.15096",
  "advanced-menus-lib": "static-1.12040",
  "ui-memberships-settings-lib": "static-1.33982",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15095",
  "simple-menus-lib": "static-1.16612"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34452",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34457",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2116",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5576",
  "hs-test-utils": "/hs-test-utils/static-1.7996",
  "hub-http": "/hub-http/static-1.6204",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11450",
  "I18n": "/I18n/static-7.1619",
  "jasmine-immutable": "/jasmine-immutable/static-1.3002",
  "jasmine-runner": "/jasmine-runner/static-1.6448",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.7003",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16649",
  "reporting-data": "/reporting-data/static-1.67447",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9380",
  "reporting-visualizations": "/reporting-visualizations/static-1.59523",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4748",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5052",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2479",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.786",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39677",
  "customer-data-objects": "/customer-data-objects/static-1.7645",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8068",
  "data-fetching-client": "/data-fetching-client/static-1.9652",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4497",
  "flux-actions": "/flux-actions/static-1.334",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85777",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4700",
  "foundations-components": "/foundations-components/static-1.7893",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11757",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7140",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3827",
  "property-translator": "/property-translator/static-1.5382",
  "quartz-config": "/quartz-config/static-1.781",
  "quartz-core": "/quartz-core/static-1.6222",
  "quick-fetch": "/quick-fetch/static-1.3900",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5328",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8150",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8075",
  "report-customization-components": "/report-customization-components/static-1.13096",
  "reporting-enablement": "/reporting-enablement/static-1.22838",
  "reporting-reports": "/reporting-reports/static-1.67125",
  "reporting-snowflake": "/reporting-snowflake/static-1.56065",
  "reporting-ui-components": "/reporting-ui-components/static-2.64718",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4632",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8922",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9211",
  "sanitize": "/sanitize/static-1.4458",
  "sanitize-text": "/sanitize-text/static-1.8123",
  "self-service-api": "/self-service-api/static-1.10229",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1729",
  "signup-constants": "/signup-constants/static-1.18805",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20815",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8025",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4745",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10974",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11132",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9526",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17955",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10996",
  "ui-images": "/ui-images/static-2.1147",
  "UIComponents": "/UIComponents/static-3.8396",
  "usage-tracker": "/usage-tracker/static-1.7326",
  "usage-tracker-container": "/usage-tracker-container/static-1.7316",
  "usage-tracker-core": "/usage-tracker-core/static-1.7176",
  "usage-tracker-public": "/usage-tracker-public/static-1.7137",
  "viral-links-lib": "/viral-links-lib/static-1.7039",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3387",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3280",
  "quartz-webpack": "/quartz-webpack/static-1.3227",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8881",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4846",
  "foundations-theming": "/foundations-theming/static-1.4400",
  "quartz-auth": "/quartz-auth/static-1.678",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9030",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5012",
  "foundations-theming-base": "/foundations-theming-base/static-1.3385",
  "HeadJS": "/HeadJS/static-2.755",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3107",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.68",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4308",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.668",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7910",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3573",
  "persist-promise": "/persist-promise/static-1.3678",
  "quartz-i18n": "/quartz-i18n/static-1.678",
  "reporting-client-types": "/reporting-client-types/static-1.2496",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.918",
  "hs-story-utils": "/hs-story-utils/static-1.9408",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9909",
  "hubspotter-http": "/hubspotter-http/static-1.4636",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.197",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7229",
  "crm-message-bus": "/crm-message-bus/static-1.42928",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22112",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13005",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13141",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9808",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3992",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6769",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6864",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3830",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.959",
  "onboarding-tours": "/onboarding-tours/static-1.16556",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13615",
  "ui-addon-teams": "/ui-addon-teams/static-1.21516",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68292",
  "customer-data-properties": "/customer-data-properties/static-1.51462",
  "forms-ai-lib": "/forms-ai-lib/static-1.4286",
  "forms-utils-lib": "/forms-utils-lib/static-1.12536",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5376",
  "react-dnd-compat": "/react-dnd-compat/static-1.4600",
  "react-tinymce": "/react-tinymce/static-1.55176",
  "tinymce-config": "/tinymce-config/static-2.54302",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10328",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4162",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.17",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1821",
  "ui-fonts": "/ui-fonts/static-1.712",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.530",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.433",
  "quartz-test": "/quartz-test/static-1.678",
  "quartz-tracking": "/quartz-tracking/static-1.382",
  "batch-promise": "/batch-promise/static-1.1521",
  "external-options-client-types": "/external-options-client-types/static-1.4142",
  "react-colorpicker": "/react-colorpicker/static-2.10191",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4236",
  "copilot-toolkit": "/copilot-toolkit/static-1.11077",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12939",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6443",
  "reporting-action-components": "/reporting-action-components/static-1.41241",
  "reporting-filters": "/reporting-filters/static-1.279",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1670",
  "reporting-plugins": "/reporting-plugins/static-1.10289",
  "ui-addon-opt": "/ui-addon-opt/static-4.8352",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25307",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4859",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.42",
  "chirp-fetch": "/chirp-fetch/static-1.1868",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4154",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5849",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4064",
  "nested-table": "/nested-table/static-1.207",
  "timezone-utils": "/timezone-utils/static-2.5225",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "chatspot-core": "/chatspot-core/static-1.21180",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2883",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9907",
  "hs-resources": "/hs-resources/static-1.135",
  "pulse": "/pulse/static-1.553",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3781",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4125",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3675",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18439",
  "growth-data-modal": "/growth-data-modal/static-1.5395",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3048",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1854",
  "navigation-components": "/navigation-components/static-1.17965",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4770",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.622",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10139",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7520",
  "ui-universal-auth": "/ui-universal-auth/static-1.8955",
  "user-context": "/user-context/static-1.5084",
  "cms-field-types": "/cms-field-types/static-1.4792",
  "content-icons-ui": "/content-icons-ui/static-1.2220",
  "integrations-lib": "/integrations-lib/static-1.16042",
  "calling-global-api": "/calling-global-api/static-1.64435",
  "calling-internal-common": "/calling-internal-common/static-1.31282",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65817",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58111",
  "commerce-products-lib": "/commerce-products-lib/static-1.9473",
  "crm-links": "/crm-links/static-1.6267",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9236",
  "file-manager-components": "/file-manager-components/static-1.23556",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4207",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.612",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48659",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3949",
  "property-value-citations": "/property-value-citations/static-1.2076",
  "smart-property-lib": "/smart-property-lib/static-1.6820",
  "tiered-pricing": "/tiered-pricing/static-1.1151",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9038",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19790",
  "tinymce-themes": "/tinymce-themes/static-1.56272",
  "data-token-picker": "/data-token-picker/static-1.16368",
  "hub-http-contrib": "/hub-http-contrib/static-1.3023",
  "interframe": "/interframe/static-3.4742",
  "tinymce-data": "/tinymce-data/static-1.40387",
  "tinymce-plugins": "/tinymce-plugins/static-1.57416",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5193",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5540",
  "magpie-types": "/magpie-types/static-1.5000",
  "simple-logging-lib": "/simple-logging-lib/static-1.3029",
  "content-assistance-lib": "/content-assistance-lib/static-1.7718",
  "dashboard-lib": "/dashboard-lib/static-1.81431",
  "ExportDialog": "/ExportDialog/static-6.10373",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18180",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18172",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8685",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9024",
  "feedback-loader": "/feedback-loader/static-1.29254",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4631",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.318",
  "purchase-motions-api": "/purchase-motions-api/static-1.5852",
  "trials-service-types": "/trials-service-types/static-1.3883",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.154",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.56",
  "directed-graph": "/directed-graph/static-1.915",
  "event-emitter": "/event-emitter/static-1.929",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1923",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1882",
  "user-context-client": "/user-context-client/static-1.4594",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.207",
  "reactive-lib": "/reactive-lib/static-1.703",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.751",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17557",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13457",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5580",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7763",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10350",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.469",
  "calling-error-reporting": "/calling-error-reporting/static-1.31289",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11019",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6523",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.897",
  "customer-data-tracking": "/customer-data-tracking/static-1.6869",
  "commerce-permissions": "/commerce-permissions/static-1.749",
  "products-iframe-lib": "/products-iframe-lib/static-1.7869",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10291",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9180",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4135",
  "video-components-external": "/video-components-external/static-1.11194",
  "video-data-lib": "/video-data-lib/static-1.34852",
  "data-agent-kit": "/data-agent-kit/static-1.160",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9992",
  "fsm": "/fsm/static-1.3713",
  "policy-lib": "/policy-lib/static-1.6759",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10055",
  "navigation-messaging": "/navigation-messaging/static-1.7292",
  "FileManagerLib": "/FileManagerLib/static-1.39196",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9043",
  "FileManagerCore": "/FileManagerCore/static-1.39055",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12404",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11379",
  "react-codemirror": "/react-codemirror/static-1.10607",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9870",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15181",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8684",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28486",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23469",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24319",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.551",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14751",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2994",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.168",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.283",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35674",
  "sales-views-client-types": "/sales-views-client-types/static-1.4245",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12179",
  "content-media-compositions": "/content-media-compositions/static-2.16186",
  "media-bridge-lib": "/media-bridge-lib/static-1.18886",
  "trellis-story-utils": "/trellis-story-utils/static-1.4497",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5883",
  "FileManagerImages": "/FileManagerImages/static-1.36707",
  "video-components": "/video-components/static-1.13197",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4518",
  "video-embed": "/video-embed/static-1.35686",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68367",
  "layout-data-lib": "/layout-data-lib/static-1.9704",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6563",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6052",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5064",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3621",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21634",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3823",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22020",
  "outpost": "/outpost/static-1.4166",
  "advanced-menus-core": "/advanced-menus-core/static-1.15096",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12040",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33982",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15095",
  "simple-menus-lib": "/simple-menus-lib/static-1.16612"
}
};
